<template>
  <div class="home">
    <!--nabbar-->
    <nav-bar ref="navbar"></nav-bar>
    <!--顶部分类和背景图-->
    <top></top>
    <div class="mr0At bgff pdLft30 pdRit30 home_warp" style="min-height: 95vh">
      <router-view @showRegister="showRegister"></router-view>
    </div>
    <!--footer-->
    <foot></foot>
    <!--返回顶部-->
    <el-backtop :right="40" :bottom="40">
      <!--返回顶部图标-->
      <div class="difcac box" style="padding-top: 4px;padding-right: 2px;">
        <i class="el-icon-top" style="color: #07838D;font-size: 30px;"></i>
      </div>
    </el-backtop>
  </div>
</template>

<script>
import navBar from "@/components/navBar";
import top from "@/components/top";
import foot from "@/components/foot";

export default {
  name: 'Home',
  components: {
    navBar,
    top,
    foot
  },
  methods: {
    showRegister() {
      this.$refs.navbar.showRegister()
    },
    inspectLogin() { //检查是否登录

    },
  },
}
</script>
<style>
  .home{
    padding-top: 4.8rem;
  }
  .home_warp{
    width:80%;
  }
  .nav_bar{
    position: fixed;
    top: 0;
    left: 0;
  }
  @media (max-width: 560px) {
    .home_warp{
      width: 100%;
    }
  }
</style>